import React from "react";

const Leaderboards: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-8 flex items-center justify-center">
      <div className="max-w-4xl w-full mx-auto bg-white shadow-lg rounded-lg p-6 text-center">
        <h1 className="text-3xl font-bold mb-6 text-gray-800">Leaderboards</h1>
        <p className="text-lg text-gray-600 mb-8">
          Game leaderboards will be displayed here.
        </p>
        {/* TODO: Add actual leaderboard display logic */}
        <div className="text-center text-gray-500">
          (Leaderboard content coming soon)
        </div>
      </div>
    </div>
  );
};

export default Leaderboards;
